import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=60f6b72b&scoped=true"
import script from "./video-play.vue?vue&type=script&lang=js"
export * from "./video-play.vue?vue&type=script&lang=js"
import style0 from "./video-play.vue?vue&type=style&index=0&id=60f6b72b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6b72b",
  null
  
)

export default component.exports